var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member-none"},[_c('img',{staticClass:"member-none-img",attrs:{"src":require("@/assets/image/brandbg.png"),"alt":""}}),_c('p',{staticClass:"member-none-text"},[_vm._v(_vm._s(_vm.imgtext))])])
}
var staticRenderFns = []

export { render, staticRenderFns }